export const ROUTE_HOME = '/';
export const ROUTE_PASSWORD_REQUEST = '/wachtwoord-vergeten';
export const ROUTE_PASSWORD_RESET = '/user/reset/';
export const ROUTE_USER_LOGOUT = '/user/logout';
export const ROUTE_ACCOUNT_LOGIN = '/login';
export const ROUTE_ACOUNT_LOGIN_EXTRA_INFO = '/login/extra-informatie'
export const ROUTE_USER_CHECK = '/user-check';
export const ROUTE_CHECKOUT_V2 = '/cart/checkoutv2';
export const ROUTE_ACCOUNT_EDIT = '/account/personal';
export const ROUTE_ACCOUNT_REGISTER = '/register';
export const ROUTE_ACCOUNT_REGISTER_RM = '/risico-monitor/register';
export const ROUTE_ACCOUNT_GRANT_RM = '/risico-monitor/grant';
export const ROUTE_FORM_QUIZ = '/form/quiz';
export const ROUTE_RESULT = '/resultaat/';
export const ROUTE_CUSTOMER_SERVICE = '/klantenservice';
export const ROUTE_NEWSLETTER_SUBSCRIBE = '/newsletter';
export const ROUTE_SUCCESS_REGISTER = '/success/register';
export const ROUTE_NEWSLETTER_SETTINGS = '/account/email';
export const ROUTE_ADDRESS_SETTINGS = '/addresses';
// Orders routes
export const ROUTE_ACCOUNT_ORDERS = '/account/orders';
export const ROUTE_ACCOUNT_ORDER_DETAIL = '/account/orders/:orderId';
export const ROUTE_ACCOUNT_ORDER_LICENSES = '/account/orders/:orderId/licenses';
// Products routes
export const ROUTE_ACCOUNT_PRODUCTS = '/account/products';
// E-learning routes
export const ROUTE_ELEARNING_ACTIVATE = '/elearning/activate/:invitationId/:token';
